import { AppConfig } from '@/config'

export const registerInspectlet = (config: AppConfig) => {
  if (config.featureFlags.enableTracking) {
    window.__insp = window.__insp || []
    window.__insp.push(['wid', config.inspectlet.id])

    if (typeof window.__inspld !== 'undefined') return
    window.__inspld = 1

    const insp = document.createElement('script')
    insp.type = 'text/javascript'
    insp.async = true
    insp.id = 'inspsync'
    insp.src =
      (document.location.protocol === 'https:' ? 'https' : 'http') +
      `://cdn.inspectlet.com/inspectlet.js?wid=${config.inspectlet.id}&r=` +
      Math.floor(new Date().getTime() / 3600000)

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript?.parentNode?.insertBefore(insp, firstScript)
  }
}
